// 创建文件en/index.js
const zh = {
    rejected: "已拒绝",
    my: "我的",
    today: "今天",
    this_week: "本周",
    this_month: "本月",
    last_month: "上月",
    this_year: "今年",
    number_of_people: "人数",
    amount: "金额",
    enter_username_id_to_search: "输入用户名ID查询",
    team_list: "团队列表",
    registration_time: "注册时间",
    selling_face_value: "出售面值",
    click_for_details: "点击详情",
    "agent_login": "代理登录",
    'SignOut': '注销账号',
    'Contact us': '联系我们',
    'Download our app': '下载我们的应用',
    'Download it from': '下载网址',
    'About Us': '关于我们',
    'Gobuy USA was founded in 2012': 'Gobuy美国成立于2012年',
    'Customer service': '客户服务',
    'frequently asked question': '常见问题',
    'Return and exchange policy': '退换货政策',
    'Shipping and distribution': '配送与发货',
    'Contact us by email': '通过邮箱联系我们',
    'Privacy Policy and Terms of Use': '隐私政策和使用条款',
    'Privacy Policy': '隐私政策',
    'Terms of use': '使用条款',
    'Upload credentials': '上传凭证',
    'The withdrawal is being processed': '提现处理中',
    'Cause of failure': '失败原因',
    'Your shopping cart is still empty': '您的购物车还是空的',
    'Log in to view the items in your cart': '登录查看购物车中的商品',
    'Browse around': '浏览一下',
    'Account correlation': '账户相关',
    'Order management': '订单管理',
    'Payment method': '付款方式',
    'Collection address': '收款地址',
    Category: '分类',
    "MyCommission": "我的佣金",
    "Gross income": "总收入",
    "Direct commission": "直接佣金",
    "Indirect commission": "间接佣金",
    "Transfer to wallet": "转入钱包",
    "Tip: The transfer amount must be greater than 10USDT": "提示：转账金额必须大于10USDT",
    "transfer": "转账",
    "commission": "佣金",
    "Please enter": "请输入",
    'Old Password': '旧密码',
    'Change password': '修改密码',
    'Amazon GIFT CARD': '亚马逊礼品卡',
    'High Priced Recycling': '高价回收',
    'Data': '日期',
    'congratulations': '恭喜',
    'Obtain': '获得',
    'ThankYouForParticipating': '谢谢参与',

    // navbar
    Home: '首页',
    Search: '搜索',
    ShoppingCart: '购物车',
    Mine: '我的',

    // 首页
    // 搜索
    EnterSearchContent: '输入搜索内容',
    'Recent searches': '最近搜索',
    'popular searches': '热门搜索',
    'Please search': '请输入您想搜索的关键词',
    'orderSearch': '输入订单或产品名称进行搜索',

    // 语言
    'Language selection': '语言选择',

    // menu
    Brand: '品牌',
    Collect: '收藏',
    Manage: '管理',
    Order: '订单',
    Wallet: '钱包',
    BlindBox: '盲盒',
    MenuGiftCard: '礼品卡',
    // HotSale
    HotSale: '最新消息在热销中...',
    // tabs
    TodaysOffer: "平台优选",
    'Phone': "手机",
    'Smart Watch': "智能手表",
    'Smart bracelet': "智能手环",

    // gobuy
    'home.gobuy.title': '惊喜正在等着您',
    'home.gobuy.periods': '盲盒轮次',
    'home.gobuy.freeze': '参与倒计时',
    'home.gobuy.drawing': '开始倒计时',
    'home.gobuy.buy': '参与',
    'home.gobuy.isbuy': '已参与',
    USDT: 'USDT',
    'home.gobuy.jackpot': '奖金池',
    Purse: '钱包',
    Box: '盲盒',
    'GetAPrize': '获取奖品',
    Discount: '折扣',
    when: '什么时候',
    points: '积分',
    seconds: '秒',
    // MessageBox
    'MessageBox.Tips': '提示',
    'MessageBox.Confirm': '确认',
    'MessageBox.Cancel': '取消',
    'MessageBox.buy.box': '您确定要购买这个盲盒吗？',
    // Toast
    'succ': '成功',
    'err': '错误',
    'box.succeeds': '购买成功',
    'box.frozen': '已参与',
    'box.issue': '每期只能购买一个盲盒',

    // 商品列表
    filter: '筛选',
    sales: '销量',
    selfOP: '自营',
    noMore: '没有更多了',
    brand: '品牌',
    confirm: '确认',
    reset: '重置',
    ComSor: '综合排序',
    MostPop: '最受欢迎',
    HighLow: '价格从高到低',
    LowHigh: '价格从低到高',
    SalVol: '销售量',
    NewArr: '新上架',

    // 购物车
    'cart.cart': '购物车',
    'cart.edit': '编辑',
    'cart.done': '完成',
    'home.cart.voucher': '获取优惠券',
    'home.cart.outstock': '缺货',
    'home.cart.offshelf': '下架',
    'Only': '仅剩',
    'left': '个',
    'Promotion': '促销',
    'cart.all': '全选',
    'cart.total': '总计',
    'cart.delete': '删除',
    'cart.checkout': '结账',

    // 我的
    'Direct': '直接',
    'Indirect': '间接',
    'MyOrders': '我的订单',
    'ViewAll': '查看全部',
    'Unpaid': '待付款',
    'ToShip': '待发货',
    'ToReceive': '待收货',
    'ToReview': '待评价',
    // 盲盒
    'MyBlindBox': '盲盒列表',
    'WaitingDraw': '等待抽奖',
    'Opened': '已开启（领取/退回）',
    // 礼品卡
    'After sale': '售后',
    'GiftCard': '回收记录',
    'RecycleGiftCard': '回收礼品卡',
    'Verifying': '校验',
    'Rebuying': '正在回购',
    'Repurchased': '待打款',
    'Paid': '已打款',
    // 常用工具
    'CommonTools': '常用工具',
    'MyWallet': '我的钱包',
    'VirtualOrders': '虚拟订单',
    'Refunds': '退款',
    'MyFriends': '我的好友',
    'ChatList': '聊天列表',
    'RealNameVerification': '实名认证',
    'MyFavorites': '我的收藏',
    'Addresses': '地址管理',
    'MyReviews': '我的评价',
    'BrowsingHistory': '浏览历史',
    'Promotions': '促销活动',
    'StoreManagement': '店铺管理',
    'BecomeASeller': '成为卖家',

    // 订单列表
    'SearchPlaceholder': '输入订单商品名称进行搜索',
    All: '全部',
    OrderNo: '订单号',
    items: '件',
    ShippingFee: '运费',
    'Refund in Progress': '退款中',
    'Cancel Order': '取消订单',
    'Refund': '退款',
    'Track Shipping': '查看物流',
    'Confirm Receipt': '确认收货',
    'Evaluate': '评价',
    'Delete': '删除',
    'Pay': '付款',
    'MessageBox.delete.order': '您确定要删除此订单吗？',
    'MessageBox.cancel.order': '您确定要取消此订单吗？',
    'MessageBox.receive.order': '此订单是否已收货？',
    // 订单详情
    'Order Details': '订单详情',
    'Pickup Code': '提货码',
    'Complaint': '投诉',
    'After-Sales': '售后',
    'Gift': '礼物',
    'Order Date': '订单日期',
    'Used voucher worth': '使用的代金券金额',
    'CNY': '人民币',
    'Payment Method': '支付方式',
    'Total Product Amount': '商品总金额',
    'Shipping Fee': '运费',
    'Amount Paid': '已付款金额',
    'Return': '退货',
    // 盲盒列表
    'Pending Draw': '待抽奖',
    'Pending Unboxing': '待开启',
    'Unboxed': '已开启',
    'Collected': '已领取',
    'Recycled': '已回收',
    'Unknown': '未知',
    'Claim': '领取',
    'Recycle': '回购',
    'Unbox': '开启',
    'MessageBox.recycle.box': '您确定要回收此盲盒吗？',
    // 盲盒详情
    'Mystery Box Details': '盲盒详情',
    'Unopened': '未开启',
    'box.opened': '未开启',
    'Claimed': '已领取',
    'Confirm Claim': '确认领取',
    'MessageBox.pick.box': '您确定要提取此盲盒吗？',
    // 盲盒提货
    'Please add address': '请添加地址',
    // 礼品卡列表
    'Face Value Total': '面值总额',
    // 礼品卡详情
    'Gift Card Details': '礼品卡详情',
    'Card number': '卡号',
    'Activation code': '激活码',
    'Actual recovery price': '实际回收价格',
    // 礼品卡回收
    'Gift Card Recycling': '礼品卡回收',
    'Confirm Recycling': '确认回收',
    'Please enter the card number': '请输入卡号',
    'Please enter the activation code': '请输入激活码',
    'MessageBox.recycle.gift': '您确定要回收此礼品卡吗？',

    // 我的钱包
    'My Wallet': '我的钱包',
    'Available Balance': '可用余额',
    'Frozen Funds': '冻结资金',
    'Recharge': '充值',
    "can": "可",
    'Withdraw': '提现',
    'Withdrawal Accounts': '提现账户',
    // 充值
    'Recharge Details': '充值详情',
    'Recharge Order No.': '充值订单号',
    'Recharge Amount': '充值金额',
    'Creation Time': '创建时间',
    'MessageBox.recharge.pop': '请输入充值金额',
    // 付款
    'payment': '付款',
    'Order submitted successfully, please select payment method': '订单提交成功，请选择支付方式',
    'Rechargeable card': '可充值卡',
    'Please enter a hash': '请输入哈希',
    'Immediate payment': '立即支付',
    'Wait for the file to load': '请等待文件加载',
    // 提现
    'Withdrawal Details': '提现详情',
    'Withdrawal Amount': '提现金额',
    'Application Time': '申请时间',
    'New Application': '新申请',
    'Payment Password': '支付密码',
    'New Payment Password': '新支付密码',
    'Recipient Information': '收款人信息',
    'Submit': '提交',
    'Add Recipient Account First': '请先添加收款账户',
    'Please bind your mobile phone or email first': '请先绑定您的手机或邮箱',
    // 设置
    'Account Settings': '账户设置',
    'Change Login Password': '修改登录密码',
    'Change Payment Password': '修改支付密码',
    'Log Out': '登出',
    'Mobile': '手机',
    'Verification Code': '验证码',
    'Email': '邮箱',
    'New Password': '新密码',
    'Confirm Password': '确认密码',
    'Modify': '修改',
    'Bind': '绑定',
    ' Mobile': ' 手机',
    ' Email': ' 邮箱',
    // 资金详情
    'Fund Details': '资金详情',
    'Withdrawal Account': '提现账号',
    'Account Type': '账户类型',
    'USDT Address (TRC20)': 'USDT地址（TRC20）',
    'Edit': '编辑',
    'Delete': '删除',
    'Add New': '添加新账号',
    'MessageBox.delete.bank': '您确定要删除此提现账号吗？',
    // 登录
    'Login': '登录',
    'Sign Up': '注册',
    'Normal Login': '普通登录',
    'Username / Email / Phone Number': '用户名/电子邮件',
    'Enter Phone Number': '请输入手机号码',
    'Enter Email': '请输入电子邮件',
    'Enter SMS Code': '请输入短信验证码',
    'Enter Password': '请输入密码',
    "enter_login_password_for_verification": "请输入登录密码验证",
    'Forgot Password': '忘记密码',
    'Third-party Login': '第三方登录',
    'Please complete the form': '请填写完整的表单',
    'WeChat': '微信',
    'Weibo': '微博',
    'QQ': 'QQ',
    'phone login': '手机登录',
    'Login Expired': '登录已过期',
    'Please enter your phone number first': '请先输入手机号码',
    'Please enter your username/email/phone number': '请输入用户名/电子邮件',
    'Please enter your password': '请输入密码',
    'Password must be at least 6 characters': '密码必须至少为 6 个字符',
    'Please enter an 11-digit phone number': '请输入 11 位手机号码',
    'Please wait for the file to finish loading': '请等待文件加载完成',
    'send': '发送',
    'signUpTips': '您的个人数据将用于支持您在整个网站上的体验，管理对您账户的访问，以及我们隐私政策中描述的其他目的。',

    // 注册
    'Sign Up': '注册',
    'Referrer': '推荐人',
    'Invitation code': '邀请码',
    'Invite friends': '邀请好友',
    'Username': '用户名',
    'Full Name': '真实姓名',
    'Set Password': '设置密码',
    'Confirm Password': '确认密码',
    'Phone Number': '手机号码',
    'Email': '电子邮件',
    'Username: 3-25 chars, letters & numbers': '用户名：3-25 个字符，字母和数字',
    '6-20 digits/letters/symbols': '6-20 位数字/字母/符号',
    'By clicking sign up, you agree to': '点击注册即表示您同意',
    'User Agreement': '用户协议',
    'Please check the user agreement': '请检查用户协议',
    'Please enter a username with 3-25 characters': '请输入 3-25 个字符的用户名',
    'Enter SMS Verification Code': '请输入短信验证码',
    'Please enter your phone number': '请输入您的手机号码',
    'Please enter the verification code': '请输入验证码',
    'Please enter a 6-digit verification code': '请输入 6 位验证码',
    'Please enter a password with 6-20 characters': '请输入 6-20 个字符的密码',
    'Please enter the confirm password': '请输入确认密码',
    'The confirm password does not match the entered password': '确认密码与输入的密码不匹配',

    // 密码恢复
    'Password Recovery': '密码恢复',
    'Forgot Password': '忘记密码',
    'Forget.email.tips': '如果您的账户尚未与电子邮件号码关联，请联系平台管理员以恢复您的密码。',

    // 通知
    'Notification Message': '通知消息',
    'Direct Message': '私信',
    'System Message': '系统消息',
    'Leave a Message': '留言',

    // 配送地址
    'Delivery Address': '配送地址',
    'The store is no longer valid, please edit the delivery address again': '该店铺不再有效，请重新编辑配送地址',
    'Default address': '默认地址',
    'Add address': '添加地址',
    'Edit address': '编辑地址',
    'MessageBox.delete.address': '您确定要删除此地址吗？',
    'name': '姓名',
    'phone': '手机号',
    'district': '区',
    'address': '地址',
    'default address': '默认地址',
    'save and use': '保存并使用',
    'save': '保存',
    'Please select a region': '请选择地区',
    'Please fill in the recipient name': '请输入收件人姓名',
    'Name must be 2-15 characters': '姓名必须为 2-15 个字符',
    'Please fill in the mobile phone number': '请输入手机号码',
    'Please select your location': '请选择您的位置',
    'Please fill in the detailed address': '请填写详细地址',

    // 浏览历史
    'Browsing History': '浏览历史',
    'Clear browsing history': '清除浏览记录',

    // 推广会员
    'Promotion member': '推广会员',
    "“PromotionPoster”": "推广海报",
    "MemberName": "会员姓名",
    "MyAssets": "我的资产",
    "DistributedAmount": "分配金额",
    "NumberOfDistributedProducts": "分配产品数量",
    "DistributedProductAmount": "分配金额",
    "MyTeam": "我的团队",
    "LevelOneMembers": "一级成员",
    "LevelTwoMembers": "二级成员",
    "PromotionPoster": "推广海报",
    "PromotionMembers": "推广成员",
    "PromotionPerformance": "推广绩效",
    "ViewPromotionLink": "点击查看推广链接",
    "PromoteViaWeChatQRCode": "通过微信二维码推广",
    "Copy": "复制",
    "BrowserNotSupportedCopyManually": "您的浏览器不支持直接复制，请手动复制",
    "GiftCardRecoveryTotal": "礼品卡回收总数",
    "TodaysGiftCardRecoveryCount": "今天的礼品卡回收数量",
    "RegistrationDate": "注册日期",
    "LastLogin": "最后登录",
    "Promotion Commission": "推广佣金",

    // userinfo 个人信息
    "Personal Info": "个人信息",
    "Nickname": "昵称",
    "Birthdate": "出生日期",
    "Save": "保存",
    "CropImage": "裁剪图片",
    "UseImage": "使用图片",

    // goodsDetail 商品详情
    "Off": "折扣",
    "Sold": "已售",
    "Product": "产品",
    "Comment": "评论",
    "Details": "详情",
    "ReportViolation": "举报",
    "Cart": "购物车",
    "ChatMessages": "聊天消息",
    "MyShop": "我的商店",
    "MerchantLogin": "商户登录",
    "Share": "分享",
    "ShareTo": "分享至",
    "WeChat": "微信",
    "Copy": "复制",
    "Poster": "海报",
    "BrowserNotSupportedCopyManually": "您的浏览器不支持直接复制，请手动复制",
    "Follow": "关注",
    "Unfollow": "取消关注",
    "PleaseSelectQuantityAndCategory": "请选定数量和类别。",
    "SelectedWithQuantity1": "已选{specification}，数量{number}。",
    "SelectedQuantity1": "已选数量{number}。",
    "SelectedWithQuantity2": "已选{specification}，数量{number}。",
    "Add to cart": "加入购物车",
    "Buy now": "立即购买",
    "Stock": "库存",
    "Pieces": " 件",
    "Quantity": "数量",
    "All": "全部",
    "Good": "好评",
    "Medium": "中评",
    "Bad": "差评",
    // 评论
    "Product review": "产品评论",
    "anonymous": "匿名",
    "noReviewInfo": "没有提供评论信息",
    "Shop Owners Response": "店主回应",
    "This product has no current reviews": "该产品目前没有评论",
    "Product details": "产品详情",
    "shop": "商店",
    "customerService": "客户服务",
    "shoppingCart": "购物车",
    "addToCart": "加入购物车",
    "buyNow": "立即购买",
    "outOfStock": "所选产品目前缺货，抱歉！",
    "notAvailable": "所选产品不再供应，抱歉！",
    "Store order message": "店铺订单消息",
    "Confirm the order": "确认订单",
    "productAmount": "产品金额",
    "discount": "折扣",
    "shippingFee": "运费",
    "subtotal": "店铺小计",
    "Submit an order": "提交订单",
    // 退货
    "refundAdd": "添加退款",
    "back": "返回",
    "refundDescription": "退款说明：",
    "proofOfRefund": "退款凭证",
    "use": "使用",
}
export default zh
